<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-wallet2"></i>
              M&eacute;todos de pago del recibo
            </h6>
            <button type="button" class="form-card__btn" @click="cancel">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">

            <!-- ARCA warning -->
            <div
              v-if="limited && header.pos != 0 && total >= 500000 && (header.letter === 'C' || header.letter === 'B')"
              class="alert alert-danger mb-3">
              Record&aacute; que para realizar una factura igual o mayor a $ 500.000 ten&eacute;s que informar a ARCA todos los datos del cliente.
            </div>

            <!-- SUMMARY -->
            <div class="payment-summary">
              <div class="total-row total-final">
                <span class="label">Total a pagar</span>
                <span class="value">$ {{ round(total, 2) }}</span>
              </div>
              <div v-if="payarray.discount > 0" class="total-row">
                <span class="label">A pagar con descuento</span>
                <span class="value">$ {{ formatoMoneda2Dec(total - payarray.discount) }}</span>
              </div>
              <div v-if="total > 0" class="total-row">
                <span class="label">Pagado en recibo</span>
                <span class="value">$ {{ round(totalpayed, 2) }}</span>
              </div>
              <div class="total-row">
                <span class="label">Efectivo</span>
                <span class="value">$ {{ payarray.cash || 0 }}</span>
              </div>
              <div class="total-row">
                <span class="label">Transferencia</span>
                <span class="value">$ {{ totalTransfer }}</span>
              </div>
              <div v-if="payarray.discount > 0" class="total-row">
                <span class="label">Descuento</span>
                <span class="value">$ {{ payarray.discount }}</span>
              </div>
              <div v-for="tpcheck in payarray.tpchecks" :key="'chk-' + tpcheck.number" class="total-row">
                <span class="label">Cheque N&deg; {{tpcheck.number}}</span>
                <span class="value">$ {{ round(tpcheck.amount, 2) }}</span>
              </div>
              <div v-for="creditcard in payarray.creditcards" :key="'cc-' + creditcard.coupon" class="total-row">
                <span class="label">{{creditcard.name}} — cup&oacute;n {{creditcard.coupon}}</span>
                <span class="value">$ {{ round(creditcard.amount, 2) }}</span>
              </div>
              <div v-for="(cc, idx) in payarray.accounts" :key="'ac-' + idx" class="total-row">
                <span class="label">Cuenta corriente (venc. {{cc.days}})</span>
                <span class="value">$ {{ cc.amount }}</span>
              </div>
              <div v-if="limited && change > 0" class="total-row">
                <span class="label">Vuelto</span>
                <span class="value text-success">$ {{ round(change, 2) }}</span>
              </div>
              <div v-if="limited && diference != 0" class="total-row">
                <span class="label">Diferencia</span>
                <span class="value text-danger">$ {{ round(diference, 2) }}</span>
              </div>
            </div>

            <div class="totals-divider"></div>

            <!-- Punto de venta -->
            <div class="form-row">
              <div class="form-group col-md-12 mb-2">
                <label class="form-card__label">Punto de venta <i class="bi bi-shop"></i></label>
                <select v-if="posnumbers.length > 1" v-model="header.posId" class="form-control">
                  <option v-for="pos in posnumbers" :key="pos.id" :value="pos.id">{{pos.number}} - {{pos.type}} - Suc.{{pos.bo_id}}</option>
                </select>
                <input v-else v-model="header.posId" type="text" class="form-control" disabled>
              </div>
            </div>

            <!-- Descuentos (cuenta corriente) -->
            <div v-if="fromCC" class="discount-accordion">
              <button
                type="button"
                class="discount-accordion__header"
                :aria-expanded="discountsOpen ? 'true' : 'false'"
                @click="discountsOpen = !discountsOpen">
                <span class="discount-accordion__title">
                  <i class="bi bi-percent"></i> Descuentos
                  <span v-if="hasActiveDiscount" class="discount-accordion__badge">Activo</span>
                </span>
                <i class="bi" :class="discountsOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </button>
              <div v-show="discountsOpen" class="discount-accordion__body form-row">
              <div class="form-group col-md-6 mb-2">
                <div class="discount-box" :class="{'discount-box--off': discountType == 1}">
                  <label class="discount-box__title">
                    <input type="radio" :value="0" v-model="discountType">
                    Descuento por pago anticipado
                  </label>
                  <div class="form-row" :class="{'discount-box--locked': discountType == 1}">
                    <div class="form-group col-md-6 mb-2">
                      <label class="form-card__label">Valor neto</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                        <input
                          v-model.number="discountValue"
                          @change="setDiscountValue()"
                          @focus="discountFocus = 'value'"
                          @blur="discountFocus = ''"
                          type="number" min="0" step="0.01"
                          class="form-control"
                          :class="{'focused': discountFocus == 'value'}"
                          placeholder="Valor neto">
                      </div>
                    </div>
                    <div class="form-group col-md-6 mb-2">
                      <label class="form-card__label">Porcentaje</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">%</span></div>
                        <input
                          v-model.number="discountPercent"
                          @change="setDiscountPercent()"
                          @focus="discountFocus = 'percent'"
                          @blur="discountFocus = ''"
                          type="number" min="0" step="0.01" max="100"
                          class="form-control"
                          :class="{'focused': discountFocus == 'percent'}"
                          placeholder="Porcentaje">
                      </div>
                    </div>
                  </div>
                  <p class="form-card__hint">Este descuento se generar&aacute; como una nota de cr&eacute;dito.</p>
                </div>
              </div>
              <div class="form-group col-md-6 mb-2">
                <div class="discount-box" :class="{'discount-box--off': discountType == 0}">
                  <label class="discount-box__title">
                    <input type="radio" :value="1" v-model="discountType">
                    Descuento aplicado en venta
                  </label>
                  <div class="form-row" :class="{'discount-box--locked': discountType == 0}">
                    <div class="form-group col-md-12 mb-2">
                      <label class="form-card__label">Porcentaje</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">%</span></div>
                        <input v-model.number="discountOnSale" type="number" placeholder="Porcentaje" min="0" step="0.01" max="100" class="form-control">
                      </div>
                    </div>
                  </div>
                  <p class="form-card__hint">Este descuento NO generar&aacute; una nota de cr&eacute;dito y s&oacute;lo afecta el c&aacute;lculo de comisiones.</p>
                </div>
              </div>
              </div>
            </div>

            <!-- Efectivo / Caja -->
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Efectivo <i class="bi bi-cash"></i></label>
                <input v-model.number="cash" type="number" min="0" step="0.01" class="form-control">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Caja destino <i class="bi bi-safe"></i></label>
                <select v-model="payarray.fund_id" class="form-control" name="fund_id">
                  <option disabled value="0">Seleccione una caja...</option>
                  <option v-for="fund in fundsCash" :key="fund.id" :value="fund.id">{{fund.name.toUpperCase()}}</option>
                </select>
              </div>
            </div>

            <!-- Transferencia / Banco -->
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Transferencia <i class="bi bi-arrow-left-right"></i></label>
                <input
                  v-model.number="transfer"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  @input="updateBanks">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Banco destino <i class="bi bi-bank"></i></label>
                <div class="bank-field">
                  <select v-model="fundTransfer" class="form-control" name="fund_id" @change="updateBanks">
                    <option disabled value="0">Seleccione una caja...</option>
                    <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                  </select>
                  <button v-if="!fromCC" type="button" class="btn btn-primary bank-field__add" title="Agregar otra transferencia" @click="addInputSelect">
                    <i class="bi bi-plus-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <template v-if="!fromCC">
              <div v-for="(inputSelect, index) in inputSelects" :key="index" class="form-row">
                <div class="form-group col-md-6 mb-2">
                  <input
                    v-model.number="inputSelect.input"
                    type="number"
                    min="0"
                    step="0.01"
                    class="form-control"
                    placeholder="0"
                    @input="updateBanks">
                </div>
                <div class="form-group col-md-6 mb-2">
                  <div class="bank-field">
                    <select v-model="inputSelect.select" class="form-control" name="fund_id" @change="updateBanks">
                      <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                    </select>
                    <button type="button" class="btn btn-outline-danger bank-field__remove" title="Quitar esta transferencia" @click="removeInputSelect(index)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </template>

            <!-- CHILD METHODS (toggleables) -->
            <div v-if="showCreditCard" class="payment-methods__child mt-3">
              <credit-card v-on:creditcardcancel="showCreditCard=false" v-on:creditcardsaved="creditCardSave"/>
            </div>
            <div v-if="showTpCheck" class="payment-methods__child mt-3">
              <tp-check v-on:tpcheckcancel="showTpCheck=false" v-on:tpchecksaved="tpCheckSave"/>
            </div>
            <div v-if="showCc" class="payment-methods__child mt-3">
              <client-account v-on:clientAccountSaved="clientAccountSaved" v-on:clientAccountCancel="showCc=false"/>
            </div>

            <!-- Concepto -->
            <div class="form-row">
              <div class="form-group col-md-12 my-4">
                <label class="form-card__label">Concepto <i class="bi bi-chat-left-text"></i></label>
                <textarea v-model="payarray.saleNote" class="form-control" rows="2"></textarea>
              </div>
            </div>

          </div>

          <div class="form-card__footer payment-methods-footer">
            <div class="payment-methods-footer__secondary">
              <button v-if="paymentMethods.cuenta_corriente==1" type="button" class="btn btn-light" @click="showCc=!showCc">
                <i class="bi bi-card-heading"></i> Cuenta corriente
              </button>
              <button v-if="paymentMethods.tarjetas==1" type="button" class="btn btn-light" @click="showCreditCard=!showCreditCard">
                <i class="bi bi-credit-card"></i> Tarjetas
              </button>
              <button v-if="paymentMethods.cheques==1" type="button" class="btn btn-light" @click="showTpCheck=!showTpCheck">
                <i class="bi bi-bank"></i> Cheques
              </button>
            </div>
            <div class="payment-methods-footer__primary">
              <button v-if="limited" type="button" class="form-card__btn" @click="modified">Modificar</button>
              <button type="button" class="form-card__btn" @click="cancel">Cancelar</button>
              <button
                type="button"
                class="form-card__btn form-card__btn--primary"
                :disabled="!(((round(diference, 2) == 0) || (limited == 0)) && cajasTransferValidas && cajaCashValida)"
                @click="finishReceipt">
                <i class="bi bi-check-lg"></i>
                Finalizar cobro
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import creditCard from './Credit-card.vue';
import clientAccount from './Client-account.vue';
import tpCheck from './Tp-check.vue';
import formatMoneyMixin from "./../../mixins/formatMoneyMixin";
import roundMixin from "./../../mixins/roundMixin.js";

export default {
  props: ['total', 'paymentMethods', 'header', 'limited', 'fundDefault', 'fromCC'],
  mixins: [formatMoneyMixin , roundMixin ,],
  data: function() {
    return {
      showCreditCard: false,
      showTpCheck: false,
      showCc: false,
      discountsOpen: false,
      discountFocus:'',
      totalpayed: 0,
      diference: 0,
      change: 0,
      funds: [],
      fundsBank: [],
      posnumbers:[],
      payarray: {
        cash: 0,
        fund_id: 0,
        banks: [],
        fundBanks_id: [],
        accounts: [],
        creditcards: [],
        tpchecks: [],
        saleNote:'',
        discount:0,
        transfer: 0,
        bankId: 0,
      },
      limitcc: null,
      discountValue: 0,
      discountPercent:0,
      discountOnSale:0,
      discountType:0,
      inputSelects: [],
      transfer: 0,
      fundTransfer: 0,
      totalTransfer: 0,

    }
  },
  mounted: function () {
    this.payarray.fund_id = this.fundDefault;
    this.payarray.cash = this.total;
    this.getSalepoints();
    this.getFunds();
    this.getLimitCC();
    // Inicializa banks/fundBanks_id con un slot vacío para que el flujo no falle
    // cuando se paga sin transferencia.
    this.updateBanks();
    this.calc();
  },
  watch: {
    payarray: {
      handler: function () {
        this.calc();
      }, deep: true
    },
    'totalpayed': {
        handler: function () {this.updateCommissionData();}
    },
    'payarray.discount': {
        handler: function () {this.updateCommissionData();}
    },
    // 'discountPercent': {
    //     handler: function (a) {this.setDiscountPercent();}
    // },
    // 'discountValue': {
    //     handler: function (a) {this.setDiscountValue();}
    // },
    'discountOnSale': {
        handler: function () {this.setDiscountOnSale();}
    }
  },
  methods: {
    calc: function () {
      this.totalpayed = 0;

      var interestCreditCards = this.payarray.creditcards.map(el => el.interest).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalCreditCards = this.payarray.creditcards.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalTpChecks = this.payarray.tpchecks.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalAccounts = this.payarray.accounts.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);

      var withoutcash = this.round(totalCreditCards,2) + this.round(interestCreditCards,2) + this.round(totalTpChecks,2) + this.round(totalAccounts,2);

      var cosa = this.total - withoutcash;
      var totalcash = this.payarray.cash;
      var totalbanks = this.totalTransfer;

      this.change = totalcash - totalbanks - cosa;

      this.totalpayed = this.round(totalcash,2) + this.round(withoutcash,2) + this.round(totalbanks,2);
      this.diference = this.round(this.total,2) - this.round(this.totalpayed,2);
    },
    updateBanks() {
      const banks = [{ amount: this.transfer }];
      const fundTransfer = [{ fund: this.fundTransfer }];
      const inputSelectsBanks = this.inputSelects.map(select => ({
        amount: select.input,
      }));
      const selectSelectsBanks = this.inputSelects.map(select => ({
        fund: select.select,
      }));
      this.payarray.fundBanks_id = fundTransfer.concat(selectSelectsBanks);
      this.payarray.banks = banks.concat(inputSelectsBanks);
      // El backend de cobranzas (addAllocationPayment) espera la transferencia
      // como escalar: transfer + bankId. En cobranzas no hay multi-transferencia,
      // así que alcanza con la transferencia principal.
      this.payarray.transfer = Number(this.transfer) || 0;
      this.payarray.bankId = this.fundTransfer;
      this.calcTotalTransfer();
    },
    addInputSelect() {
      this.inputSelects.push({ input: 0, select: '' });
    },
    removeInputSelect(index) {
      this.inputSelects.splice(index, 1);
      this.updateBanks();
    },
    calcTotalTransfer() {
      this.totalTransfer = this.payarray.banks.reduce((sum, bank) => sum + (Number(bank.amount) || 0), 0);
    },
    creditCardSave: function(obj) {
      this.payarray.creditcards.push(obj);
      this.showCreditCard=false;
      this.$emit('paymentmethodschanged',this.payarray);
    },
    tpCheckSave: function(obj) {
      this.payarray.tpchecks.push(obj);
      this.showTpCheck=false;
    },
    fromdateUpdated: function (date) {
      this.header.service_fromdate = date;
    },
    clientAccountSaved: function (obj) {
      this.payarray.accounts.push(obj);
      this.showCc=false;
    },
    modified: function () {
      this.$emit('paymentmethodschanged',{});
      this.$emit('close');
    },
    cancel: function () {
        if (!this.fromCC){
            if (!this.limited) {
                window.location.href = '/ventas/cc-clientes/detalle/'+this.header.client_id;
            } else {
                window.location.href = '/sales/create';
            }
        }else{
            this.modified();
        }
    },
    finishReceipt: function () {
      this.$emit('paymentmethodsclose',this.payarray);
      this.$emit('close');
    },
    getFunds() {
      var vm = this;
      this.$http.get('/api/funds/listSimple')
            .then(response => {
              if(response.data) {
                vm.funds = response.data.data.filter(fund => fund.type != "Tarjeta de Credito");
                vm.fundsBank = response.data.data.filter(fund => fund.type === "Banco");
                // Pre-seleccionar la caja por defecto solo si es de efectivo; si no, dejar el placeholder.
                if (!vm.funds.some(f => f.id == vm.fundDefault && f.type === "Efectivo")) {
                  vm.payarray.fund_id = 0;
                }
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    getSalepoints() {
      var vm = this;
      this.$http.get('/api/configs/pos/list')
            .then(response => {
              if(response.data) {
                vm.posnumbers = response.data.data;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    getLimitCC() {
      this.$http.get('/api/clients/getLimitClientAccount/' + this.header.client_id)
            .then(response => {
              if(response.data) {
                if(response.data.data < 0) {
                  this.limitcc = 0;
                } else {
                  this.limitcc = response.data.data;
                }
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    setDiscountValue() {
      var app = this;
      this.payarray.discount = app.discountValue;
      this.discountPercent= app.round((app.discountValue * 100)/app.total,2) ;
    },
    setDiscountPercent() {
      var app = this;
      app.payarray.discount = app.round((app.discountPercent * app.total)/100,2);
      app.discountValue = app.payarray.discount;
      this.updateCommissionData()
    },
    setDiscountOnSale: function(){
      var app = this;
      app.payarray.discount = 0;
      app.discountValue = 0;
      app.discountPercent=0;
      this.updateCommissionData()
    },
    updateCommissionData(){
        var comdata = {
            'discountPercent': this.discountPercent,
            'discountOnSale': this.discountOnSale,
            'discountType':this.discountType,
            'totalToCom' : this.totalpayed,
        };
        this.$emit('comissionUpdated',comdata);
    },
    round(a){
      return (a);
    }
  },
  computed: {
      // Hay descuento cargado por cualquiera de las dos vías (nota de crédito o sobre venta).
      hasActiveDiscount: function () {
        return this.payarray.discount > 0 || this.discountOnSale > 0;
      },
      // Caja destino para efectivo: solo cajas de tipo Efectivo (no bancos ni tarjetas).
      fundsCash: function () {
        return this.funds.filter(fund => fund.type === "Efectivo");
      },
      // Si hay efectivo cargado, hay que elegir una caja de efectivo destino.
      cajaCashValida: function () {
        return this.payarray.cash <= 0 || this.payarray.fund_id != 0;
      },
      cash: {
            get: function () {
                return this.payarray.cash;
            },
            set: function (value) {
                if (value==''){
                    this.payarray.cash=0;
                }else{
                    this.payarray.cash=value;
                }
            }
        },
      // Toda línea de transferencia con monto > 0 debe tener una caja banco elegida
      // (no la opción "Seleccione una caja..."). Bloquea el cierre si falta.
      cajasTransferValidas: function () {
        if (this.transfer > 0 && !this.fundTransfer) return false;
        for (var i = 0; i < this.inputSelects.length; i++) {
          if (this.inputSelects[i].input > 0 && !this.inputSelects[i].select) return false;
        }
        return true;
      },
  },
  components: {
    clientAccount,
    tpCheck,
    creditCard
  }
}
</script>

<style scoped>
/* ---- Modal shell (mismo lenguaje visual que el POS) ---- */
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

/* ---- Resumen de pago ---- */
.payment-summary .total-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 2px 0;
  font-size: 14px;
}

.payment-summary .total-row .label {
  color: var(--text-muted);
}

.payment-summary .total-row .value {
  font-weight: 600;
  color: var(--text);
  text-align: right;
}

.payment-summary .total-final {
  padding: 4px 0;
}

.payment-summary .total-final .label {
  font-size: 24px;
  font-weight: 700;
  color: var(--text);
}

.payment-summary .total-final .value {
  font-size: 26px;
  font-weight: 700;
  color: #4477bd;
}

.totals-divider {
  height: 1px;
  background: var(--border-soft);
  margin: 12px 0;
}

/* ---- Acordeón de descuentos ---- */
.discount-accordion {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.discount-accordion__header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: var(--surface-subtle);
  border: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.discount-accordion__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.discount-accordion__badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: #4477bd;
  color: #fff;
}

.discount-accordion__body {
  padding: 12px 14px 4px;
}

/* ---- Cajas de descuento ---- */
.discount-box {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 12px 14px;
  background: var(--surface-subtle);
  height: 100%;
}

.discount-box__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 10px;
}

.discount-box--off {
  color: var(--text-muted);
  background-color: var(--surface-muted);
}

.discount-box--locked {
  pointer-events: none;
  opacity: 0.5;
}

.focused {
  background-color: #f5c05d;
  font-weight: bold;
}

/* ---- Transferencias (input + select banco) ---- */
.bank-field {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.bank-field__add,
.bank-field__remove {
  flex-shrink: 0;
  width: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ---- Métodos hijos (tarjeta / cheque / cuenta) ---- */
.payment-methods__child {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 16px;
  background: var(--surface-subtle);
}

/* ---- Footer ---- */
.payment-methods-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.payment-methods-footer__secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.payment-methods-footer__secondary .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.payment-methods-footer__primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ---- Transición ---- */
.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
